import clsx from 'clsx'
import { type ReactElement } from 'react'
import { useBrandInfos } from '~/api/queries/global'
import { Tooltip } from '~/components/Global/Elements/Tooltip/Tooltip'
import {
  userListItem,
  userListItemPicture,
  userListWrapper
} from '~/components/Global/Elements/UsersList/UsersList.css'

export type UsersListProps = {
  users: {
    id: number
    firstname: string
    lastname: string
    picture?: string
  }[]
  className?: string
}

export const UsersList = ({
  users,
  className
}: UsersListProps): ReactElement => {
  const { data: brandInfos } = useBrandInfos()
  return (
    <Tooltip
      text={users
        .map((user) => `${user.firstname} ${user.lastname}`)
        .join(', ')}
      className={clsx(userListWrapper, className)}
    >
      {users.map((user, index) => (
        <div key={user.id} className={userListItem}>
          {user.picture && (
            <img
              src={
                user.picture.slice(0, 1) === '/'
                  ? brandInfos?.legacyUrl + user.picture
                  : user.picture
              }
              alt={`${user.firstname} ${user.lastname}`}
              width={32}
              className={userListItemPicture}
            />
          )}
          {!user.picture && (
            <div>
              {user.firstname.substring(0, 1)}
              {user.lastname.substring(0, 1)}
            </div>
          )}
        </div>
      ))}
    </Tooltip>
  )
}
